import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Badge,
  notification,
  Space,
  Tabs,
  Typography,
  Popconfirm,
  Row,
  Col,
} from 'antd';

import AjaxTable from '../../../components/AjaxTable';
import CustomButton from '../../../components/CustomButton';

import BreadcrumbContainer from '../../../containers/Breadcrumb';

import INTERNAL_LINKS from '../../../enums/InternalLinks';
import MESSAGES from '../../../enums/Messages';

import {
  filter as filterMass,
  remove as removeMass,
  getCounters as getCountersMass,
} from '../../../api/module/mass_contract_modifications';

import {
  filter,
  remove,
  getCounters,
  projectSelector,
  getIMCounters,
} from '../../../api/module/contract_modifications';

import './style.scss';
import { ClockCircleOutlined } from '@ant-design/icons';
import PdfViewer from '../../../components/PdfViewer';
import { generateTemplateURL } from '../../../api/module/template';
import { CustomSelector } from '../../../components';
import {
  catchExceptionSRate,
  getLocalStorage,
} from '../../../utils/helpers/helpers';

const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const initCounters = () => ({
  approval: (
    <ClockCircleOutlined style={{ marginLeft: '13px', marginRight: '3px' }} />
  ),
  created: (
    <ClockCircleOutlined style={{ marginLeft: '13px', marginRight: '3px' }} />
  ),
  drafts: (
    <ClockCircleOutlined style={{ marginLeft: '13px', marginRight: '3px' }} />
  ),
  return: (
    <ClockCircleOutlined style={{ marginLeft: '13px', marginRight: '3px' }} />
  ),
  returned: (
    <ClockCircleOutlined style={{ marginLeft: '13px', marginRight: '3px' }} />
  ),
  validated: (
    <ClockCircleOutlined style={{ marginLeft: '13px', marginRight: '3px' }} />
  ),
});

const initIMCounters = () => ({
  individual: (
    <ClockCircleOutlined style={{ marginLeft: '13px', marginRight: '3px' }} />
  ),
  massive: (
    <ClockCircleOutlined style={{ marginLeft: '13px', marginRight: '3px' }} />
  ),
});

const ContractModificationList = ({ project_id, perms, sendPerm }) => {
  const [userId] = useState(parseInt(getLocalStorage('userId')));
  const [imCounters, setIMCounters] = useState(initIMCounters);
  const [counters, setCounters] = useState(initCounters);

  const { Crear: createPerm, Editar: updatePerm, Borrar: deletePerm } = perms;

  const [activeTab, setActiveTab] = useState(createPerm ? 0 : sendPerm ? 3 : 1);

  const [reloadSource, setReloadSource] = useState(project_id);
  const [deleteID, setDeleteID] = useState(undefined);

  const [pdfUrl, setPDFUrl] = useState(undefined);
  const [loadingPDF, setLoadingPDF] = useState(undefined);

  const [massTab, setMassTab] = useState(0);

  const getURLPDF = async (record) => {
    try {
      setLoadingPDF(record.id);
      let response = await generateTemplateURL({
        person: record.tercero,
        term: record.termino,
        contract: record.contrato,
        modification: record.id,
        template: record.tipo_plantilla,
        version: record.plantilla_version,
      });
      setPDFUrl(response.data.url);
      setLoadingPDF(null);
    } catch (err) {
      setLoadingPDF(null);
      console.log(err);
    }
  };

  const getCountersData = async () => {
    try {
      let res;
      setIMCounters(initIMCounters);
      setCounters(initCounters);
      const imRes = await getIMCounters(project_id);
      setIMCounters(imRes.data.results);
      if (massTab) res = await getCountersMass(project_id);
      else res = await getCounters(project_id);
      setCounters(res.data.results);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getCountersData();
    setReloadSource(project_id);
  }, [project_id, massTab]);

  const deleteDataSource = async (id) => {
    try {
      setDeleteID(id);
      if (massTab) await removeMass(id);
      else await remove(id);
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_DELETE_MSG,
        duration: 2,
      });
      await getCountersData();
      setReloadSource({});
      setDeleteID(undefined);
    } catch (err) {
      catchExceptionSRate(err);
      setDeleteID(undefined);
    }
  };

  const columns = [
    {
      title: 'Nombre Contratista/Proveedor',
      dataIndex: 'contratista_nombre',
    },
    {
      title: 'Tipo Documento',
      dataIndex: 'tipo_identificacion',
    },
    {
      title: 'Nro. Documento',
      dataIndex: 'identificacion',
    },
    {
      title: 'Cargo / Rol',
      dataIndex: 'cargo_nombre',
    },
    {
      title: 'No. Contrato',
      dataIndex: 'contrato_num',
    },
    ...([1, 4].includes(activeTab)
      ? [
          {
            title: 'Enviado a',
            dataIndex: 'enviado_a',
          },
        ]
      : []),
    {
      title: 'Acciones',
      dataIndex: 'accion',
      fixed: 'right',
      width: activeTab === 5 ? 300 : 200,
      render: (_, record) => (
        <Space direction={'vertical'} style={{ width: '100%' }}>
          <CustomButton
            block
            text="Generar PDF"
            onClick={() => {
              getURLPDF(record);
            }}
            loading={loadingPDF === record.id}
            style={{ width: '100%' }}
          />
          {activeTab !== 5 && activeTab !== 4 && activeTab !== 1 && (
            <CustomButton
              block
              type="default"
              style={{ width: '100%' }}
              text={
                <Link
                  to={`${INTERNAL_LINKS.CONTRACT_MODIFICATIONS}-form/${project_id}/${record.id}`}
                >
                  Editar
                </Link>
              }
            />
          )}
          {activeTab !== 5 &&
            activeTab !== 4 &&
            activeTab !== 1 &&
            deletePerm && (
              <Popconfirm
                title={MESSAGES.DELETE_CONFIRM_MSG}
                onConfirm={() => {
                  deleteDataSource(record.id);
                }}
                okText="Si"
                cancelText="No"
              >
                <CustomButton
                  style={{ width: '100%' }}
                  danger
                  block
                  type="default"
                  text="Eliminar"
                  loading={record.id === deleteID}
                />
              </Popconfirm>
            )}
        </Space>
      ),
    },
  ];

  const columnsMass = [
    {
      title: 'Identificador interno de modificación',
      dataIndex: 'identificador_masivo',
    },
    {
      title: 'Cargo / Rol',
      dataIndex: 'cargo_nombre',
    },
    ...([1, 4].includes(activeTab)
      ? [
          {
            title: 'Enviado a',
            dataIndex: 'enviado_a',
          },
        ]
      : []),
    {
      title: 'Acciones',
      dataIndex: 'accion',
      fixed: 'right',
      width: activeTab === 5 ? 300 : 200,
      render: (_, record) => (
        <Space direction={'vertical'} style={{ width: '100%' }}>
          <CustomButton
            block
            text="Generar PDF"
            onClick={() => {
              getURLPDF(record);
            }}
            loading={loadingPDF === record.id}
            style={{ width: '100%' }}
          />
          {activeTab !== 5 && activeTab !== 4 && activeTab !== 1 && (
            <CustomButton
              block
              type="default"
              style={{ width: '100%' }}
              text={
                <Link
                  to={`${INTERNAL_LINKS.CONTRACT_MASS_MODIFICATIONS}/${project_id}/${record.id}`}
                >
                  Editar
                </Link>
              }
            />
          )}
          {activeTab === 0 && deletePerm && (
            <Popconfirm
              title={MESSAGES.DELETE_CONFIRM_MSG}
              onConfirm={() => {
                deleteDataSource(record.id);
              }}
              okText="Si"
              cancelText="No"
            >
              <CustomButton
                style={{ width: '100%' }}
                danger
                block
                type="default"
                text="Eliminar"
                loading={record.id === deleteID}
              />
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  return (
    <>
      {createPerm && (
        <>
          <Paragraph>
            A continuación, encontrará una tabla con los registros de
            modificaciones contractuales creados para este proyecto. Si desea
            agregar una nueva modificación contractual, por favor, haga click en
            el botón "Nueva modificación contractual"
          </Paragraph>
          <Space>
            <CustomButton
              text={
                <Link
                  to={`${INTERNAL_LINKS.CONTRACT_MODIFICATIONS}-form/${project_id}`}
                >
                  Nueva modificación contractual - Individual
                </Link>
              }
            />
            <CustomButton
              text={
                <Link
                  to={`${INTERNAL_LINKS.CONTRACT_MASS_MODIFICATIONS}/${project_id}`}
                >
                  Nueva modificación contractual - Masiva
                </Link>
              }
            />
          </Space>

          <br />
        </>
      )}
      <Tabs
        type="card"
        destroyInactiveTabPane={true}
        style={{ marginTop: 15 }}
        onChange={(value) => setMassTab(parseInt(value))}
        defaultActiveKey={massTab}
        renderTabBar={(props, DefTabBar) => {
          return <DefTabBar {...props} className="lilac_tabbar" />;
        }}
      >
        <TabPane
          tab={
            <Paragraph>
              Individual
              <Badge showZero count={imCounters.individual} />
            </Paragraph>
          }
          key={0}
        >
          <Tabs
            type="card"
            defaultActiveKey={activeTab}
            destroyInactiveTabPane={true}
            onChange={(value) => {
              setActiveTab(parseInt(value));
            }}
            style={{ marginTop: 15 }}
          >
            {createPerm && (
              <TabPane
                tab={
                  <Paragraph>
                    Borrador
                    <Badge showZero count={counters.drafts} />
                  </Paragraph>
                }
                key={0}
              >
                <AjaxTable
                  endpointFetch={async (page, pageSize) => {
                    return await filter(
                      `?filter[proyecto]=${project_id}&filter[estado_proceso__sigla]=CT-MC-B&filter[usuario]=${userId}`,
                      page,
                      pageSize,
                    );
                  }}
                  columns={columns}
                  reloadSource={reloadSource}
                />
              </TabPane>
            )}
            {updatePerm && (
              <TabPane
                tab={
                  <Paragraph>
                    En revisión
                    <Badge showZero count={counters.created} />
                  </Paragraph>
                }
                key={1}
              >
                <AjaxTable
                  endpointFetch={async (page, pageSize) => {
                    return await filter(
                      `?filter[proyecto]=${project_id}&filter[estado_proceso__sigla]=CT-MC-R&filter[usuario_origen]=${userId}`,
                      page,
                      pageSize,
                    );
                  }}
                  columns={columns}
                  reloadSource={reloadSource}
                />
              </TabPane>
            )}
            {updatePerm && (
              <TabPane
                tab={
                  <Paragraph>
                    Devueltos a mí
                    <Badge showZero count={counters.return} />
                  </Paragraph>
                }
                key={2}
              >
                <AjaxTable
                  endpointFetch={async (page, pageSize) => {
                    const thisQuery = `filter[proyecto]=${project_id}&filter[estado_proceso__sigla]=CT-MC-D&filter[usuario_destino]=${userId}`;
                    return await filter(`?${thisQuery}`, page, pageSize);
                  }}
                  columns={columns}
                  reloadSource={reloadSource}
                />
              </TabPane>
            )}
            {updatePerm && (
              <TabPane
                tab={
                  <Paragraph>
                    Para aprobación
                    <Badge showZero count={counters.approval} />
                  </Paragraph>
                }
                key={3}
              >
                <AjaxTable
                  endpointFetch={async (page, pageSize) => {
                    const thisQuery = `filter[proyecto]=${project_id}&filter[estado_proceso__sigla]=CT-MC-R&filter[usuario_destino]=${userId}`;
                    return await filter(`?${thisQuery}`, page, pageSize);
                  }}
                  columns={columns}
                  reloadSource={reloadSource}
                />
              </TabPane>
            )}
            {updatePerm && (
              <TabPane
                tab={
                  <Paragraph>
                    Devueltos por mí
                    <Badge showZero count={counters.returned} />
                  </Paragraph>
                }
                key={4}
              >
                <AjaxTable
                  endpointFetch={async (page, pageSize) => {
                    const thisQuery = `filter[proyecto]=${project_id}&filter[estado_proceso__sigla]=CT-MC-D&filter[usuario_origen]=${userId}`;
                    return await filter(`?${thisQuery}`, page, pageSize);
                  }}
                  columns={columns}
                  reloadSource={reloadSource}
                />
              </TabPane>
            )}
            {sendPerm && (
              <TabPane
                tab={
                  <Paragraph>
                    Validados
                    <Badge showZero count={counters.validated} />
                  </Paragraph>
                }
                key={5}
              >
                <AjaxTable
                  endpoint={filter}
                  query={`?filter[proyecto]=${project_id}&filter[estado_proceso__sigla]=CT-MC-V&filter[usuario_destino]=${userId}`}
                  searchInput
                  columns={columns}
                  reloadSource={reloadSource}
                />
              </TabPane>
            )}
          </Tabs>
        </TabPane>
        <TabPane
          tab={
            <Paragraph>
              Masivo
              <Badge showZero count={imCounters.massive} />
            </Paragraph>
          }
          key={1}
        >
          <Tabs
            type="card"
            defaultActiveKey={activeTab}
            destroyInactiveTabPane={true}
            onChange={(value) => {
              setActiveTab(parseInt(value));
            }}
            style={{ marginTop: 15 }}
          >
            {createPerm && (
              <TabPane
                tab={
                  <Paragraph>
                    Borrador
                    <Badge showZero count={counters.drafts} />
                  </Paragraph>
                }
                key={0}
              >
                <AjaxTable
                  endpointFetch={async (page, pageSize) => {
                    return await filterMass(
                      `?filter[proyecto]=${project_id}&filter[estado_proceso__sigla]=CT-MC-B&filter[usuario]=${userId}`,
                      page,
                      pageSize,
                    );
                  }}
                  columns={columnsMass}
                  reloadSource={reloadSource}
                />
              </TabPane>
            )}
            {updatePerm && (
              <TabPane
                tab={
                  <Paragraph>
                    En revisión
                    <Badge showZero count={counters.created} />
                  </Paragraph>
                }
                key={1}
              >
                <AjaxTable
                  endpointFetch={async (page, pageSize) => {
                    return await filterMass(
                      `?filter[proyecto]=${project_id}&filter[estado_proceso__sigla]=CT-MC-R&filter[usuario_origen]=${userId}`,
                      page,
                      pageSize,
                    );
                  }}
                  columns={columnsMass}
                  reloadSource={reloadSource}
                />
              </TabPane>
            )}
            {updatePerm && (
              <TabPane
                tab={
                  <Paragraph>
                    Devueltos a mí
                    <Badge showZero count={counters.return} />
                  </Paragraph>
                }
                key={2}
              >
                <AjaxTable
                  endpointFetch={async (page, pageSize) => {
                    const thisQuery = `filter[proyecto]=${project_id}&filter[estado_proceso__sigla]=CT-MC-D&filter[usuario_destino]=${userId}`;
                    return await filterMass(`?${thisQuery}`, page, pageSize);
                  }}
                  columns={columnsMass}
                  reloadSource={reloadSource}
                />
              </TabPane>
            )}
            {updatePerm && (
              <TabPane
                tab={
                  <Paragraph>
                    Para aprobación
                    <Badge showZero count={counters.approval} />
                  </Paragraph>
                }
                key={3}
              >
                <AjaxTable
                  endpointFetch={async (page, pageSize) => {
                    const thisQuery = `filter[proyecto]=${project_id}&filter[estado_proceso__sigla]=CT-MC-R&filter[usuario_destino]=${userId}`;
                    return await filterMass(`?${thisQuery}`, page, pageSize);
                  }}
                  columns={columnsMass}
                  reloadSource={reloadSource}
                />
              </TabPane>
            )}
            {updatePerm && (
              <TabPane
                tab={
                  <Paragraph>
                    Devueltos por mí
                    <Badge showZero count={counters.returned} />
                  </Paragraph>
                }
                key={4}
              >
                <AjaxTable
                  endpointFetch={async (page, pageSize) => {
                    const thisQuery = `filter[proyecto]=${project_id}&filter[estado_proceso__sigla]=CT-MC-D&filter[usuario_origen]=${userId}`;
                    return await filterMass(`?${thisQuery}`, page, pageSize);
                  }}
                  columns={columnsMass}
                  reloadSource={reloadSource}
                />
              </TabPane>
            )}
            {sendPerm && (
              <TabPane
                tab={
                  <Paragraph>
                    Validados
                    <Badge showZero count={counters.validated} />
                  </Paragraph>
                }
                key={5}
              >
                <AjaxTable
                  endpoint={filterMass}
                  query={`?filter[proyecto]=${project_id}&filter[estado_proceso__sigla]=CT-MC-V&filter[usuario_destino]=${userId}`}
                  searchInput
                  columns={columnsMass}
                  reloadSource={reloadSource}
                />
              </TabPane>
            )}
          </Tabs>
        </TabPane>
      </Tabs>

      <PdfViewer
        pdf={pdfUrl}
        onCancel={() => setPDFUrl(undefined)}
        open={pdfUrl}
        isWord={true}
      />
    </>
  );
};

const ContractModificationHome = ({ match, perms, sendPerm }) => {
  const [project, setProject] = useState(null);
  const breadcrumbItems = [
    {
      text: 'Modificaciones Contractuales',
    },
  ];

  return (
    <>
      <BreadcrumbContainer items={breadcrumbItems} />
      <div className="box-title">
        <Title>MÓDULO MODIFICACIONES CONTRACTUALES</Title>
      </div>
      <Paragraph>
        Seleccione el proyecto en el cual desea realizar las modificaciones
        contractuales
      </Paragraph>
      <Row align="middle" gutter={8}>
        <Col>Proyecto</Col>
        <Col flex="auto">
          <CustomSelector
            onChange={(value) => setProject(value)}
            initialValue={
              match.params.type && match.params.type === 'project'
                ? parseInt(match.params.id)
                : undefined
            }
            onLoad={(value) => {
              if (match.params.type === 'project') setProject(value.value);
            }}
            selectorProps={{
              style: { width: '100%' },
              placeholder: 'Seleccione el proyecto...',
            }}
            endpointFetch={async () => {
              return await projectSelector();
            }}
          />
        </Col>
      </Row>
      <br />
      {project != null && (
        <>
          <ContractModificationList
            project_id={project}
            perms={perms}
            sendPerm={sendPerm}
          />
        </>
      )}
    </>
  );
};

export default ContractModificationHome;
